<div>
        <input
            class="btn btn-success float-end"
            type="button"
            value="Add"
            (click)="onAddQRCodeSetup()"
            [disabled]="formId == 0"
        />
        <input
            #qrCodeSetupButton
            type="button"
            [attr.data-bs-toggle]="'modal'"
            [attr.data-bs-target]="'#add-qr-code-setup'"
            class="hidden"
        />
        <div 
                class="modal" 
                id="add-qr-code-setup" 
                tabindex="-1" 
                role="dialog">
                <app-qrcode-form
                    #qrCodeForm
                    *ngIf="showQRCodeSetupModal"
                    [isDisplayEntry]="isDisplayEntry"
                    [isAllowUploadedCSV]="isAllowUploadedCSV"
                    [isViewMode]="isViewMode"
                    [isEditMode]="isEditMode"
                    [qrCodeSetup]="qrCodeSetup"
                    [qrCodeFormQuestions]="qrCodeFormQuestions"
                    (onCloseQRCodeSetting)="onCloseQRCodeSetting($event)"
                    (onSaveQRCodeSetting)="onSaveQRCodeSetting()"
                ></app-qrcode-form>
        </div>
</div>
<div class="clearfix"></div>
    <div>
        <data-table 
            [dataset]="qrCodeSetupRegister" 
            [showExport]="false" 
            [paginator]="false" 
            [class]="'override-height'"
            [loading]="loading"
        >
            <column
                [header]="'ID'"
                [visible]="false"
                [value]="'entryNumber'"
                [filterable]="false"
                [sortable]="false"
                [width]="'100px'">
            </column>
            <column
                [value]="'name'"
                [header]="'Name'"
                [filterable]="false"
                [sortable]="false"
                [styleClass]="'text-start'"
                width="200px"
                [frozen]="false">
            </column>
            <column
                [value]="'lastUpdated'"
                [header]="'Last Updated'"
                [filterable]="false"
                [sortable]="false"
                [styleClass]="'text-start'"
                width="240px">
            </column>
            <column
                [value]="'lastUpdatedBy'"
                [header]="'Last Updated By'"
                [filterable]="false"
                [sortable]="false"
                [styleClass]="'text-start'"
                width="200px">
            </column>
            <column
                [value]="'roleAccessType'"
                [header]="'Access Type'"
                [filterable]="false"
                [sortable]="false"
                [styleClass]="'text-start'"
                width="220px">
            </column>
            <column
                [value]="'status'"
                [header]="'Status'"
                [filterable]="false"
                [sortable]="false"
                [styleClass]="'text-start'"
                width="220px">
            </column>
            <column
                [options]="'options'"
                [filterable]="false"
                [sortable]="false"
                [styleClass]="'text-center'">
            </column>
        </data-table>
    </div>
